import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, Dropdown } from 'semantic-ui-react';
import { StyledModal } from './SharedStyles';
import * as api from '../services/api';

const sizeOptions = [
  { key: '1', text: 'Small', value: 1 },
  { key: '2', text: 'Medium', value: 2 },
  { key: '3', text: 'Large', value: 3 },
];

const defaultFormData = {
  label: 'New didit',
  content: '',
  url: '',
  due: '',
  size: 1,
  isTemplate: false,
};

const ParentTaskModal = ({ open, onClose, onCreated }) => {
  const [formData, setFormData] = useState({ ...defaultFormData });
  const [delegates, setDelegates] = useState([]);
  const [selectedDelegateUuids, setSelectedDelegateUuids] = useState([]);

  useEffect(() => {
    if (open) {
      api.getDelegates().then(setDelegates).catch(err => console.error('Error loading delegates:', err));
    }
  }, [open]);

  const handleChange = (e, { name, value }) => {
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      const taskData = {
        ...formData,
        due: formData.due ? new Date(formData.due).toISOString() : null,
      };
      const res = await api.createParentTask(taskData);
      if (selectedDelegateUuids.length > 0) {
        await api.setTaskDelegates(res.uuid, selectedDelegateUuids);
      }
      setFormData({ ...defaultFormData });
      setSelectedDelegateUuids([]);
      onClose();
      onCreated(res.uuid);
    } catch (error) {
      console.error('Error creating parent task:', error);
    }
  };

  const delegateOptions = delegates.map(d => ({
    key: d.uuid,
    text: d.name,
    value: d.uuid,
    description: d.email || d.mobile || '',
  }));

  return (
    <StyledModal open={open} onClose={onClose}>
      <Modal.Header>Create Task List</Modal.Header>
      <Modal.Content>
        <Form onSubmit={handleSubmit}>
          <Form.Field>
            <label>Label</label>
            <Form.Input name="label" value={formData.label} onChange={handleChange} placeholder="New didit" />
          </Form.Field>
          <Form.Field>
            <label>Content</label>
            <Form.TextArea name="content" value={formData.content} onChange={handleChange} />
          </Form.Field>
          <Form.Field>
            <label>URL</label>
            <Form.Input name="url" value={formData.url} onChange={handleChange} />
          </Form.Field>
          <Form.Field>
            <label>Due Date</label>
            <Form.Input type="date" name="due" value={formData.due} onChange={handleChange} />
          </Form.Field>
          <Form.Field>
            <label>Size</label>
            <Form.Select name="size" options={sizeOptions} value={formData.size} onChange={handleChange} />
          </Form.Field>
          <Form.Field>
            <Form.Checkbox
              label="Save as template"
              checked={formData.isTemplate}
              onChange={(e, { checked }) => setFormData(prev => ({ ...prev, isTemplate: checked }))}
            />
          </Form.Field>
          {delegates.length > 0 && (
            <Form.Field>
              <label>Delegates</label>
              <Dropdown
                placeholder="Select delegates"
                fluid
                multiple
                search
                selection
                options={delegateOptions}
                value={selectedDelegateUuids}
                onChange={(e, { value }) => setSelectedDelegateUuids(value)}
              />
            </Form.Field>
          )}
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>Cancel</Button>
        <Button positive onClick={handleSubmit}>Create</Button>
      </Modal.Actions>
    </StyledModal>
  );
};

export default ParentTaskModal;
